import iso from "src/assets/iso.json";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { GetMyBots, ListTopics } from "src/app/core/services/outbound";
import {
  bot_status_color_map,
  bot_status_map,
  published_status_map,
  user_search_placeholder_map,
} from "src/app/core/services/constants";

@Component({
  selector: "app-topic-selector",
  templateUrl: "./topic-selector.component.html",
  styleUrls: ["./topic-selector.component.scss"],
  providers: [],
})

export class TopicSelectorComponent implements OnInit, OnDestroy {
  @Input() mode = "list";
  @Input() single = false;
  @Input() selectedTopics = [];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 25;
  currentPage = 0;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  payload = {};
  searchForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  loading = false;
  topicList: {};
  selectedTopicsList = {};
  verifySubscription: any;
  listTopicsSubscription: any;

  constructor(
    private ws: WebsocketService,
    private formBuilder: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private mdw: MiddlwareService
  ) {}

  ngOnInit() {
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 1;
    this.topicList = {};

    this.searchForm = this.formBuilder.group({
      member_id: new UntypedFormControl(null),
      search_value: new UntypedFormControl(null),
      status: new UntypedFormControl(""),
      role_id: new UntypedFormControl(""),
      date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
    });

    this.listTopicsSubscription = this.ws.listTopicsContainer$.subscribe((listTopicsData) => {
      if (listTopicsData && listTopicsData.ref === this.component_ref) {
        this.loading = false;
        this.currentPage = listTopicsData.page_number;
        if (listTopicsData.data.length == 0 && this.currentPage == 1) {
          this.search_message = "No results matched your search criteria";
        } else {
          this.search_message = "";
        }

        listTopicsData.data.forEach((topic) => {
          topic.created_date = new Date(topic.created_date);
          topic.created_date =
            topic.created_date.getDate() +
            " " +
            this.monthNames[topic.created_date.getMonth()] +
            ", " +
            topic.created_date.getFullYear();
          this.topicList[String(topic.id)] = topic;
        });

        this.page = [];
        for (let i = 0; i < this.pageSize; i++) {
          if (
            Object.keys(this.topicList)[
              i + (this.currentPage - 1) * this.pageSize
            ]
          ) {
            this.page.push(
              this.topicList[
                Object.keys(this.topicList)[
                  i + (this.currentPage - 1) * this.pageSize
                ]
              ]
            );
          }
        }

        document
          .getElementById("pagination_back")
          .classList.remove("d-none");
        document
          .getElementById("pagination_back")
          .classList.add("enablePointer");
        document
          .getElementById("pagination_next")
          .classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");

        this.eop = false;
        if (listTopicsData.eop) {
          this.eop = true;
          document
            .getElementById("pagination_next")
            .classList.add("d-none");
          document
            .getElementById("pagination_next")
            .classList.remove("enablePointer");
        } else {
          document
            .getElementById("pagination_next")
            .classList.remove("d-none");
          document
            .getElementById("pagination_next")
            .classList.add("enablePointer");
        }
        if (this.currentPage == 1) {
          document
            .getElementById("pagination_back")
            .classList.add("d-none");
          document
            .getElementById("pagination_back")
            .classList.remove("enablePointer");
        } else {
          document
            .getElementById("pagination_back")
            .classList.remove("d-none");
          document
            .getElementById("pagination_back")
            .classList.add("enablePointer");
        }
        if (this.currentPage == 1 && listTopicsData.eop) {
          document
            .getElementById("showPageNumber")
            .classList.add("invisible");
        } else {
          document
            .getElementById("showPageNumber")
            .classList.remove("invisible");
        }
        this.ref.detectChanges();
      }
    });

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      if (verifyData) {
        this.loading = true;
        this.ws.processMethod(new ListTopics(this.currentPage, this.pageSize, this.component_ref));
      }
    });

    console.log(this.selectedTopics);
    if (this.selectedTopics != null && this.selectedTopics.length > 0) {
      for (let i = 0; this.selectedTopics.length > i; i++) {
        this.selectedTopicsList[this.selectedTopics[i].id] = this.selectedTopics[i];
      }
    }
  }

  get f() {
    return this.searchForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.searchForm.valid) {
    } else {
      return;
    }
  }

  botSearch() {
    let filter = this.f.search_value.value.toUpperCase();
    let type = this.f.search_type.value;
    let list: any = document.querySelectorAll("#bots-list");
    for (let i = 0; i < list.length; i++) {
      let el = list[i].querySelector(`#${type}`).getElementsByTagName("p")[0];
      let value = el.innerText;
      if (value.toLocaleUpperCase().indexOf(filter) > -1) {
        list[i].style.display = "";
      } else {
        list[i].style.display = "none";
      }
    }
  }

  selectUsers(data) {
    if (this.single) {
      if (this.selectedTopicsList[data.id]) {
        delete this.selectedTopicsList[data.id];
      } else {
        this.selectedTopicsList = {};
        this.selectedTopicsList[data.id] = data;
      }
    } else {
      if (this.selectedTopicsList[data.id]) {
        delete this.selectedTopicsList[data.id];
      } else {
        this.selectedTopicsList[data.id] = data;
      }
    }
  }

  insertTopic() {
    const selected = Object.values(this.selectedTopicsList);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedTopicsList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedTopicsList[id] ? true : false;
  }

  searchTypeChanged() {
    if (this.searchForm.value.search_type === "member_id") {
      this.searchForm
        .get("search_value")
        .setValidators([Validators.pattern(/^[0-9]*$/)]);
    } else {
      this.searchForm.get("search_value").clearValidators();
    }
    this.searchForm.get("search_value").updateValueAndValidity();
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");
    this.payload["type"] = "BookingChannel";
    // this.ws.processMethod(
    //   new GetWorkflows(
    //     this.currentPage,
    //     this.component_ref,
    //     this.payload["workflow_id"],
    //     this.payload["name"],
    //     this.payload["created_date"]
    //   )
    // );
  }

  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.topicList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.topicList[
              Object.keys(this.topicList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.topicList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  ngOnDestroy(): void {
    if (this.listTopicsSubscription) {
      this.listTopicsSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }
}
